var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import produce from 'immer';
import { cloneDeep } from 'lodash';
import moment from 'moment-timezone';
import React, { useEffect, useReducer } from 'react';
import { Button, ButtonMode, ButtonSize, ButtonVariant } from '../Components/Button';
import { ButtonGroup } from '../Components/ButtonGroup';
import { useDebounce } from '../Hooks/useDebounce';
import { emptyGuid } from '../Shared/Constants';
import { ValidDateFormats } from '../Shared/DateUtilities';
import { ApplicationStorageKeys, loadFromLocalStorage, saveToLocalStorage } from '../Shared/LocalStorage';
import { divider } from '../Styles/Colours';
import styles from './MedicationsSummaryFilter.module.css';
export var convertFilterToQueryObject = function (filter, encounterAuthoringSystem, encounterAuthoringSystemForeignKey, serviceAuthoringSystem, serviceAuthoringSystemForeignKey, sortColumn, sortOrder) { return ({
    stoppedFilter: filter.stoppedMedications,
    stoppedFilterTimestamp: filter.stoppedMedications === StoppedMedications.LessThan
        ? moment().add(-24, 'hours').format(ValidDateFormats.NodeDateTimeTimezone)
        : null,
    encounter: {
        id: emptyGuid,
        authoringSystem: encounterAuthoringSystem,
        authoringSystemForeignKey: encounterAuthoringSystemForeignKey
    },
    service: {
        id: emptyGuid,
        authoringSystem: serviceAuthoringSystem,
        authoringSystemForeignKey: serviceAuthoringSystemForeignKey
    },
    sortColumn: sortColumn,
    sortOrder: sortOrder
}); };
export var StoppedMedications;
(function (StoppedMedications) {
    StoppedMedications["None"] = "none";
    StoppedMedications["All"] = "all";
    StoppedMedications["LessThan"] = "lessThan";
})(StoppedMedications || (StoppedMedications = {}));
var clearFilterDefaults = {
    stoppedMedications: StoppedMedications.None
};
var filterReducer = produce(function (state, action) {
    switch (action.type) {
        case 'UpdateField':
            state[action.field] = action.value;
            break;
        case 'Clear':
            return cloneDeep(clearFilterDefaults);
    }
});
export function useMedicationsSummaryFilter(filterUpdatedCallback, userId) {
    var _a = __read(useReducer(filterReducer, loadFromLocalStorage(ApplicationStorageKeys.MedicationsSummaryFilters, cloneDeep(clearFilterDefaults), userId)), 2), state = _a[0], dispatch = _a[1];
    useEffect(function () {
        saveToLocalStorage(ApplicationStorageKeys.MedicationsSummaryFilters, state, userId);
    }, [state]);
    var debouncedState = useDebounce(state);
    useEffect(function () {
        filterUpdatedCallback(debouncedState);
    }, [debouncedState]);
    var updateField = function (field) { return function (value) {
        dispatch({ type: 'UpdateField', field: field, value: value });
    }; };
    var clearField = function (field, clearValue) { return function () {
        dispatch({ type: 'UpdateField', field: field, value: clearValue });
    }; };
    var clearFilter = function () {
        dispatch({ type: 'Clear' });
    };
    var refresh = function () {
        filterUpdatedCallback(debouncedState);
    };
    return {
        state: state,
        updateField: updateField,
        clearField: clearField,
        refresh: refresh,
        clearFilter: clearFilter
    };
}
export function MedicationsSummaryFilter(props) {
    return (React.createElement("div", { className: styles.containFilters },
        React.createElement("div", { className: styles.controls },
            React.createElement("div", { className: styles.buttonGroup },
                React.createElement("div", { className: styles.sectionTitle }, "Stopped medications"),
                React.createElement(ButtonGroup, { borderColour: divider },
                    React.createElement(Button, { size: ButtonSize.small, width: '33%', mode: props.state.stoppedMedications === StoppedMedications.None
                            ? ButtonMode.solid
                            : ButtonMode.border, variant: props.state.stoppedMedications === StoppedMedications.None
                            ? ButtonVariant.primary
                            : ButtonVariant.light, onClick: function () { return props.updateField('stoppedMedications')(StoppedMedications.None); }, testId: 'filter-stopped-medications-none' }, "None"),
                    React.createElement(Button, { size: ButtonSize.small, width: '33%', mode: props.state.stoppedMedications === StoppedMedications.All
                            ? ButtonMode.solid
                            : ButtonMode.border, variant: props.state.stoppedMedications === StoppedMedications.All
                            ? ButtonVariant.primary
                            : ButtonVariant.light, onClick: function () { return props.updateField('stoppedMedications')(StoppedMedications.All); }, testId: 'filter-stopped-medications-all' }, "All"),
                    React.createElement(Button, { size: ButtonSize.small, width: '33%', mode: props.state.stoppedMedications === StoppedMedications.LessThan
                            ? ButtonMode.solid
                            : ButtonMode.border, variant: props.state.stoppedMedications === StoppedMedications.LessThan
                            ? ButtonVariant.primary
                            : ButtonVariant.light, onClick: function () { return props.updateField('stoppedMedications')(StoppedMedications.LessThan); }, testId: 'filter-stopped-medications-day' }, "24 Hours")))),
        React.createElement("div", { className: styles.clearButtonContainer },
            React.createElement(Button, { onClick: props.clearFilter, width: '100%', size: ButtonSize.small, variant: ButtonVariant.light, testId: 'clear-filter', color: 'primary' }, "Clear all filters"))));
}
